import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface CustomerBehalfData {
  url: string
}

/**
 * `POST /admin-api/customers/{customer}/behalf` — a signed customer-space autologin link. It is a
 * credential: hand it straight to the opened window, never log or keep it.
 */
export const useCustomerBehalf = async (customerId: number): Promise<string | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.customer.behalf', { customer_id: customerId })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url)
    const behalf: CustomerBehalfData | null = data.data || null

    if (!data.success || !behalf?.url) {
      toast.error(data.message)
      return null
    }

    return behalf.url
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  }
}
